<template>
  <logo-layout 
    :title="$t('pages.comercializacionDigital')"
  >
    <v-layout justify-center>
      <v-flex xs12 sm8 md6 lg5 xl3>
        <v-card>
          <v-container fluid>
            <v-form v-model="valid">
              <v-text-field
                v-model="usermail"
                :name="usermail"
                :rules="[rules.required, rules.validarNifOEmail, rules.max(100)]"
                :label="$t('general.misc.usuario')"
              />
              <v-text-field
                v-model="password"
                :name="password"
                :rules="[rules.required, rules.noSoloEspacios, rules.max(20)]"
                :type="mostrarPassword ? 'text' : 'password'"
                :append-icon="!mostrarPassword ? 'visibility' : 'visibility_off'"
                @click:append="mostrarPassword = !mostrarPassword"
                :label="$t('pages.incrustado.contrasena')"
                @keyup.enter.native="loguear(usermail, password)"
              />
              <v-layout row>
                <v-spacer></v-spacer>
                <v-btn @click="resetPassword()" flat small class="titleColor--text" style="padding-right:0; margin-top: 0">{{$t('pages.incrustado.olvidoContrasena')}}</v-btn>
              </v-layout>
            </v-form>
            <v-layout justify-center style="padding-top: 10px">
              <v-btn 
                color="primary"
                @click="loguear(usermail, password)"
                :disabled="!valid || botonDesactivado"
                :loading="botonDesactivado"> 
                {{$t('pages.iniciarSesion')}}
              </v-btn>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </logo-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import rulesMixin from '@/mixins/rules.js'
export default {
  mixins: [rulesMixin],
  data () {
    return {
      valid: false,
      botonDesactivado: false,
      password: '',
      usermail: '',
      mostrarPassword: false
    }
  },
  computed: {
    ...mapGetters({
      usuario: 'login/usuario'
    })
  },
  methods: {
    ...mapActions({
      logIn: 'login/logIn',
      addAlert: 'alerts/add'
    }),
    resetPassword () {
      this.$router.push({name: 'login.resetPassword'})
    },
    async loguear (usermail, password) {
      this.botonDesactivado = true
      try {
        await this.logIn({usermail, password})
        this.$router.push({name: 'home'})
      } catch (error) {
        this.botonDesactivado = false
        this.addAlert({texto: error.message, color: 'error'})
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/login.vue